// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link, NavLink } from 'react-router-dom'
import { withRouter } from 'react-router'

// Redux:
import { setLocale, setMenuOpenState, setLocaleMenuOpenState } from 'church-theme-library/redux/actions/site'

class LocaleSelect extends React.Component {
	handleClick = () => {
		const { dispatch, localeMenuIsOpen } = this.props

		dispatch( setLocaleMenuOpenState( ! localeMenuIsOpen ) )

		dispatch( setMenuOpenState( false ) )
	}

	handleLinkClick = ( e ) => {
		const { dispatch, closeMenu } = this.props
		const locale = e.target.getAttribute( 'data-locale' )

		dispatch( setLocale( locale ) )

		dispatch( setLocaleMenuOpenState( false ) )
		dispatch( setMenuOpenState( false ) )
	}

	render() {
		const { locale, locales, hasMultipleLocales, localeMenuIsOpen } = this.props
		let currentName = ''
		let className = localeMenuIsOpen ? 'is-open' : ''
		className += ' locale-select'

		if ( ! hasMultipleLocales ) {
			return null
		}

		const markup = locales ? locales.map( ( e ) => {
			let className = ''

			if ( e.slug == locale ) {
				currentName = e.name
				className = 'is-active'
			}

			return (
				<li key={ e.slug }>
					<span className={ className } onClick={ this.handleLinkClick } data-locale={ e.slug }>
						{ e.name }
					</span>
				</li>
			)
		}) : ''

		return (
			<div className="locale-wrap">
				<div className={ className } onClick={ this.handleClick }>
					<div className="-current">
						<i className="icon-language" aria-hidden="true"></i>

						<div className="-text">{ currentName }</div>
					</div>

					<div className="-dropdown">
						<section>
							<ul>
								{ markup }
							</ul>
						</section>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		menuIsOpen: state.site.menuIsOpen,
		localeMenuIsOpen: state.site.localeMenuIsOpen,
		locale: state.site.locale,
		locales: state.site.locales,
		hasMultipleLocales: state.site.hasMultipleLocales
	}
}

export default withRouter( connect( mapStateToProps )( LocaleSelect ) )
